import { styled } from '@mui/material/styles';
import { DialogContent, Typography, Button } from '@mui/material';

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  boxSizing: 'border-box',
  backgroundImage: 'radial-gradient(circle at center, #94F2FF 20%, #F0E0FF 45%, #FBF7FE 65%, #F0E0FF 75%, #94F2FF 90%)',
  backgroundSize: '300% 300%',
  animation: 'gradientMove 12s ease-in-out infinite',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '694px',
  minHeight: '491px',
  margin: '0 auto',
  padding: theme.spacing(6),
  gap: theme.spacing(2),
  borderRadius: '12px',
  textAlign: 'center',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(3),
  },
  '@keyframes gradientMove': {
    '0%': { backgroundPosition: '50% 50%' },
    '33%': { backgroundPosition: '150% 50%' },
    '66%': { backgroundPosition: '10% 150%' },
    '100%': { backgroundPosition: '50% 50%' },
  },
}));

export const TextContainer = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  maxWidth: '472px',
}));

export const Title = styled(Typography)(({ theme }) => ({
  width: '100%',
  maxWidth: '371px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  gap: '6px',
  marginBottom: '15px',
  textAlign: 'center',
}));

export const WelcomeText = styled('span')(({ theme }) => ({
  fontFamily: 'IBM Plex Sans, sans-serif',
  fontWeight: 700,
  fontSize: '39px',
  lineHeight: '34px',
  color: '#2E2177',
  display: 'flex',
  alignItems: 'center',
  height: '34px',
  [theme.breakpoints.up('md')]: {
    fontSize: '2.4rem',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '39px',
  },
}));

export const JeddSpan = styled('span')(() => ({
  color: '#301B72',
  opacity: 1,
  height: '37.19px',
  width: '77px',
  fontSize: '38px',
  fontWeight: '900',
}));

export const JeddGroup = styled('span')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '2px',
  [theme.breakpoints.up('lg')]: {
    gap: '4px',
  },
}));

export const Subtitle = styled(Typography)(({ theme }) => ({
  fontFamily: 'IBM Plex Sans',
  fontWeight: 600,
  fontSize: '16px',
  lineHeight: '21px',
  textAlign: 'center',
  color: '#56515B',
  width: '100%',
  maxWidth: '472px',
  marginBottom: '25px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
}));

export const GetStartedButton = styled(Button)(({ theme }) => ({
  width: '150px',
  height: '45px',
  borderRadius: '900px',
  backgroundColor: '#7200E0',
  whiteSpace: 'nowrap',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '4px',
  padding: '8px 16px',
  fontSize: '14px',
  fontFamily: "'IBM Plex Sans', sans-serif",
  fontWeight: 500,
  lineHeight: '20px',
  textTransform: 'none',
  color: '#FFFFFF',
  '&:hover': {
    backgroundColor: '#7200E0',
  },
  [theme.breakpoints.up('lg')]: {
    fontSize: '16px',
    padding: '12px 24px',
  },
}));